import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'
import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit'
import { MessageRowItem } from 'pages/Communications/model/message'

export interface SidebarState {
  isSidebarVisible: boolean
  opened: string
  active: string
  sidebar_roles: UserRoleTypeWithStatus[] | null
  inbox: number | null
}

const initialState: SidebarState = {
  isSidebarVisible: true,
  opened: '',
  active: '',
  inbox: null,
  sidebar_roles: null,
}

const sidebar = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.isSidebarVisible = !state.isSidebarVisible
    },
    setOpenedList(state, { payload }: PayloadAction<string>) {
      state.opened = payload
    },
    setActive(state, { payload }: PayloadAction<string>) {
      state.active = payload
    },
    setRoles(state: SidebarState, { payload }: PayloadAction<UserRoleTypeWithStatus[]>) {
      state.sidebar_roles = payload ?? []
    },
    setInbox(state: SidebarState, { payload }: PayloadAction<number | null>) {
      state.inbox = payload === null ? null : (payload ?? 0)
    },
  },
})

export const { toggleSidebar, setOpenedList, setActive, setRoles, setInbox } = sidebar.actions
export const getUserRoles = createAction('sidebar/getUserRoles')
export const getUserInbox = createAction('sidebar/getUserInbox')

export default sidebar.reducer
